export const GET_LIST_CHAT_ROOM = 'GET_LIST_CHAT_ROOM';
export const GET_LIST_CHAT_ROOM_SUCCESS = 'GET_LIST_CHAT_ROOM_SUCCESS';
export const GET_LIST_CHAT_ROOM_FAILED = 'GET_LIST_CHAT_ROOM_FAILED';
export const GET_UNREAD_CHAT_ROOMS_COUNT = 'GET_UNREAD_CHAT_ROOMS_COUNT';
export const GET_UNREAD_CHAT_ROOMS_COUNT_SUCCESS = 'GET_UNREAD_CHAT_ROOMS_COUNT_SUCCESS';
export const GET_UNREAD_CHAT_ROOMS_COUNT_FAILED = 'GET_UNREAD_CHAT_ROOMS_COUNT_FAILED';
export const RESET_UNREAD_CHAT_ROOMS_COUNT = 'RESET_UNREAD_CHAT_ROOMS_COUNT';

export const RESET_LIST_CHAT_ROOM = 'RESET_LIST_CHAT_ROOM';

export const GET_CHAT_ROOM_DETAIL = 'GET_CHAT_ROOM_DETAIL';
export const GET_CHAT_ROOM_DETAIL_SUCCESS = 'GET_CHAT_ROOM_DETAIL_SUCCESS';
export const GET_CHAT_ROOM_DETAIL_FAILED = 'GET_CHAT_ROOM_DETAIL_FAILED';

export const RESET_CHAT_ROOM_DETAIL = 'RESET_CHAT_ROOM_DETAIL';

export const GET_CHAT_ROOM_MESSAGES = 'GET_CHAT_ROOM_MESSAGES';
export const GET_CHAT_ROOM_MESSAGES_SUCCESS = 'GET_CHAT_ROOM_MESSAGES_SUCCESS';
export const GET_CHAT_ROOM_MESSAGES_FAILED = 'GET_CHAT_ROOM_MESSAGES_FAILED';

export const RESET_CHAT_ROOM_MESSAGES = 'RESET_CHAT_ROOM_MESSAGES';

export const SEND_CHAT_MESSAGE = 'SEND_CHAT_MESSAGE';
export const SEND_CHAT_MESSAGE_SUCCESS = 'SEND_CHAT_MESSAGE_SUCCESS';
export const SEND_CHAT_MESSAGE_FAILED = 'SEND_CHAT_MESSAGE_FAILED';
export const SEND_CHAT_MESSAGE_COMPLETED = 'SEND_CHAT_MESSAGE_COMPLETED';

export const RECEIVE_CHAT_ROOM_MESSAGE = 'RECEIVE_CHAT_ROOM_MESSAGE';

export const RECEIVE_NEW_CHAT_ROOM = 'RECEIVE_NEW_CHAT_ROOM';

export const READ_CHAT_ROOM = 'READ_CHAT_ROOM';
export const READ_CHAT_ROOM_SUCCESS = 'READ_CHAT_ROOM_SUCCESS';
export const READ_CHAT_ROOM_FAILED = 'READ_CHAT_ROOM_FAILED';
